/* eslint-disable no-underscore-dangle */
import Form from 'form-backend-validation';

/**
 * An easy way to validate forms using back end logic.
 */
class Way2Form extends Form {
    /**
     * Submit the form.
     *
     * @param {string} initRequestType
     * @param {string} url
     *
     * @return {Promise}
     */
    submit(initRequestType, url) {
        let requestType = initRequestType;

        if (process.env.VUE_APP_MOCK) {
            requestType = 'get';
        }
        // this.withOptions({
        //     http: Api
        // });

        this.__validateRequestType(requestType);
        this.errors.clear();
        this.processing = true;
        this.successful = false;

        if (this.__http.defaults) {
            // Allow sending and receiving cookies
            this.__http.defaults.withCredentials = true;
        }

        return new Promise((resolve, reject) => {
            let data = this.data();

            if (this.hasFiles()) {
                data = objectToFormData(this.data());
            }

            this.__http[requestType](url, data)
                .then(response => {
                    this.processing = false;
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    this.processing = false;
                    this.onFail(error);

                    reject(error);
                });
        });
    }
}

export default Way2Form;
